import './MptcfeLib.js'
import '../less/main.less'
import article_video_immerse from './article_video_immerse/index'
import collection from './collection'
import Util from '../utils/util.js'
import plugin from "./plugin"
import Cookie from 'js-cookie'
import goSpecialUrl from '../utils/go-special-url'
window.eventBus = Util.eventBus
window.goSpecialUrl = goSpecialUrl;
import { authorAccessArticle,jumpHome } from '@/utils/article-access-limit.js'
import { getArticleContent } from '@/js/request/commentRequest'

var params = Util.parseURL(window.location.href);
if(params._trans_){
    Cookie.set('_trans_', params._trans_, { expires: 7 });
}

const authorAccessArticleFn = ()=>{
    authorAccessArticle(async ()=>{
        try {
            const res = await getArticleContent()
            if(res?.data?.fulltext?.content) {
                article_video_immerse()
                const titleDom = document.querySelector('.article-main .title-info')
                if(titleDom) titleDom.innerHTML = res?.data?.fulltext?.title
            }else {
                jumpHome()
            } 
        } catch (error) {
            jumpHome()
        }
        
    })
}

window.h5_sohu = {
    article_video_immerse,
    authorAccessArticle: authorAccessArticleFn,
    collection,
};
window.h5_sohu.plugin = plugin

